// Efecto de clic de los botones de antd (reemplaza el "happy work" genérico).
// Al hacer clic, salen íconos de herramientas / artículos de Multiproductos
// (martillo, llave, desarmador, foco, enchufe…) disparados en ráfaga radial
// desde el botón. Se conecta UNA vez en el ConfigProvider raíz (src/index.js):
//   <ConfigProvider wave={{ showEffect: showHerramientasEffect }}>
// Los íconos son Font Awesome (ya cargado en public/index.html).
const HERRAMIENTAS_ICONS = [
  { cls: "fa-solid fa-hammer", color: "#f90336" },
  { cls: "fa-solid fa-wrench", color: "#6b7280" },
  { cls: "fa-solid fa-screwdriver", color: "#f59e0b" },
  { cls: "fa-solid fa-lightbulb", color: "#eab308" },
  { cls: "fa-solid fa-plug", color: "#3d0011" },
  { cls: "fa-solid fa-gear", color: "#9ca3af" },
  { cls: "fa-solid fa-bolt", color: "#f97316" },
  { cls: "fa-solid fa-toolbox", color: "#d40230" },
];

const PARTICLE_COUNT = 16;

const createHolder = (node) => {
  const rect = node.getBoundingClientRect();
  const holder = document.createElement("div");
  holder.style.position = "fixed";
  holder.style.left = `${rect.left + rect.width / 2}px`;
  holder.style.top = `${rect.top + rect.height / 2}px`;
  holder.style.pointerEvents = "none";
  holder.style.zIndex = "1100";
  document.body.appendChild(holder);
  return { holder, rect };
};

// Ráfaga radial compacta: apenas rebasa el borde del botón.
export const showHerramientasEffect = (node, { component }) => {
  if (component !== "Button") return;
  const { holder, rect } = createHolder(node);
  const halfH = rect.height / 2;

  for (let i = 0; i < PARTICLE_COUNT; i += 1) {
    const { cls, color } = HERRAMIENTAS_ICONS[i % HERRAMIENTAS_ICONS.length];
    const angle = (360 / PARTICLE_COUNT) * i + (Math.random() * 14 - 7);
    const rad = (angle * Math.PI) / 180;
    const dist = halfH + 6 + Math.random() * 12;
    const endX = Math.cos(rad) * dist;
    const endY = Math.sin(rad) * dist;
    const spin = (Math.random() * 200 - 100).toFixed(0);

    const icon = document.createElement("i");
    icon.className = cls;
    icon.style.position = "absolute";
    icon.style.left = "0px";
    icon.style.top = "0px";
    icon.style.color = color;
    icon.style.fontSize = "7px";
    icon.style.opacity = "1";
    icon.style.transform = "translate(-50%, -50%) rotate(0deg) scale(0.5)";
    icon.style.transition =
      "left .38s ease-out, top .38s ease-out, font-size .38s ease-out, opacity .3s ease-out, transform .38s ease-out";
    holder.appendChild(icon);

    requestAnimationFrame(() => {
      icon.style.left = `${endX}px`;
      icon.style.top = `${endY}px`;
      icon.style.fontSize = "11px";
      icon.style.transform = `translate(-50%, -50%) rotate(${spin}deg) scale(1)`;
    });

    setTimeout(() => {
      icon.style.opacity = "0";
      icon.style.fontSize = "7px";
    }, 260);
  }

  setTimeout(() => holder.remove(), 560);
};
